__webpack_require__.p = "/ui-refresh-navigtion-tooltips-anim-removed-/onboarding/";